module.exports = __webpack_public_path__ + "static/media/fly0239.c99dfc72.webp";